import get from 'lodash/get';
import isObject from 'lodash/isObject';
import values from 'lodash/values';
import { createReducer } from 'redux-act';
import { extrasResource, tldsInfoResource } from './actions';
const initialState = {
  extraFields: [],
  tldsInfos: {}
};
const reducer = createReducer({
  [extrasResource.fetch.success.getType()]: (state, {
    response
  }) => {
    const descExtras = get(response, 'data.desc_extras', {});
    const {
      properties,
      required
    } = descExtras;
    if (Array.isArray(required)) {
      required.forEach(requireField => {
        if (properties[requireField]) {
          properties[requireField].required = true;
        }
      });
    }
    const tempFields = isObject(properties) && values(properties) || [];
    const extraFields = tempFields.reduce((acc, field) => {
      const newField = {
        label: field.label,
        description: field.description,
        field: field.field,
        type: field.type,
        family: 'extra',
        required: field.required || false
      };
      if (field.type === 'enum') {
        newField.values = field.field_values;
      }
      return acc.concat(newField);
    }, []);
    return {
      ...state,
      extraFields
    };
  },
  [tldsInfoResource.fetch.success.getType()]: (state, {
    fqdn,
    response
  }) => ({
    ...state,
    tldsInfos: {
      ...state.tldsInfos,
      [fqdn]: response.data
    }
  }),
  [tldsInfoResource.fetch.failure.getType()]: (state, {
    fqdn
  }) => ({
    ...state,
    tldsInfos: {
      ...state.tldsInfos,
      [fqdn]: {}
    }
  })
}, initialState);
export default reducer;